import { AssessmentOrder } from "../../../system/Domain";
import moment from "moment";
import TextGroup from "../../VehicleSales/TextGroup";
import TextLine from "../../VehicleSales/TextLine";
import DekraAssessmentOrderStatusPill from "./DekraAssessmentOrderStatusPill";

const getAssessmentOrderStatusDate = (order: AssessmentOrder) => {
	switch (order.assessmentStatus) {
		case "Transferred":
			return moment(order.dateTransferred).format("LLLL");
		case "Delayed":
			return moment(order.dateDelayed).format("LLLL");
		case "Confirmed":
			return order.plannedAssessmentDate ? moment(order.plannedAssessmentDate).format("LLLL") : "Datum fehlt";
		case "Assigned":
			return moment(order.dateAssigned).format("LLLL");
		case "Cancelled":
			return moment(order.dateCancelled).format("LLLL");
		case "Done":
			return moment(order.assessmentDate).format("LLLL");
	}
};

const getAssessmentOrderStatusLabel = (order: AssessmentOrder) => {
	switch (order.assessmentStatus) {
		case "Transferred":
			return "Übertragen am";
		case "Delayed":
			return "Verzögerung am";
		case "Confirmed":
			return "Begutachtung geplant am";
		case "Assigned":
			return "Gutachter zugewiesen am";
		case "Cancelled":
			return "Storniert am";
		case "Done":
			return "Abgeschlossen am";
	}
};

interface Props {
	order: AssessmentOrder
}

const DekraAssessmentOrderTile = ({ order }: Props) => {
	const knownStatus = order.assessmentStatus === "Transferred"
		|| order.assessmentStatus === "Delayed"
		|| order.assessmentStatus === "Confirmed"
		|| order.assessmentStatus === "Assigned"
		|| order.assessmentStatus === "Cancelled"
		|| order.assessmentStatus === "Done";

	return (
		<>
			<TextGroup>
				<TextLine
					label="Dekra Status"
					value={<DekraAssessmentOrderStatusPill assessmentOrder={order} />}
				/>
			</TextGroup>
			<TextGroup>
				{!order.externalReference && (
					<TextLine
						label="Übertragungsstatus"
						color="warning"
						value="Der Auftrag wurde nicht via Schnittstelle übertragen"
					/>
				)}
				{order.externalReference && (
					<>
						{knownStatus && (
							<TextLine
								label={getAssessmentOrderStatusLabel(order)}
								value={getAssessmentOrderStatusDate(order)}
							/>
						)}
						{!knownStatus && order.assessmentStatus === "Unknown" && (
							<TextLine label="Status" value="Unbekannt" />
						)}
						{!knownStatus && order.assessmentStatus !== "Unknown" && (
							<TextLine label="Unbekannter Status" value={order.assessmentStatus} color="warning" />
						)}
						<TextLine
							label="Auftragsnummer"
							value={order.externalReference ? order.externalReference : "Unbekannt"}
						/>
					</>
				)}
			</TextGroup>
			<TextGroup>
				{order.dateDelayed && (
					<TextLine label="Verzögerung gemeldet am" value={moment(order.dateDelayed).format("LLLL")} />
				)}
				{order.reasonForDelay && (
					<TextLine label="Verzögerungsgrund" value={order.reasonForDelay} />
				)}
			</TextGroup>
		</>
	);
};

export default DekraAssessmentOrderTile;
